import { ModalBody, ModalFooter } from 'baseui/modal'
import { useStyletron } from 'baseui'
import BackToSearchButton from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/BackToSearchButton'

const SearchResultsModal = ({ 
  title, 
  message, 
  isError = false, 
  onBackToSearch,
  backButtonText,
  children 
}) => {
  const [css] = useStyletron()

  const modalBodyStyle = {
    padding: '32px',
    textAlign: 'center',
    ...(isError && { color: '#d44333' }),
  }

  const modalFooterStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    backgroundColor: '#f7f7f7',
    borderTop: '0.0625rem solid #e0e0e0',
    padding: '1rem 1.5rem',
  }

  return (
    <>
      <ModalBody>
        <div className={css(modalBodyStyle)}>
          <h3>{title}</h3>
          {message && <p>{message}</p>}
          {children}
        </div>
      </ModalBody>
      <ModalFooter style={modalFooterStyle}>
        <BackToSearchButton onClick={onBackToSearch} text={backButtonText} />
      </ModalFooter>
    </>
  )
}

export default SearchResultsModal
